import * as React from 'react';

import classNames from 'classnames';

import { Icon } from '@base/components/Icon';

import { IconMailik } from '@icons';

import * as s from './MainMenuBalance.scss';

export interface IMainMenuBalanceProps {
	className?: string;
	balance: number;
	innerMargin?: number;
}

export const MainMenuBalance: React.FC<IMainMenuBalanceProps> = (props: IMainMenuBalanceProps ) => {
	const {
		className,
		balance,
		innerMargin,
	} = props;

	// const pay = () => {
	// 	alert('pay');
	// };

	return (
		<div className={classNames(s.block, className)}>
			<Icon className={s.icon} glyph={IconMailik}/>
			<span className={s.text} style={innerMargin ? { marginLeft: `${innerMargin}px` } : null}>{balance}</span>
			{/* todo: пока не разберёмся с ДМР, кнопка отображаться не будет */}
			{/* <span */}
			{/*	className={s.button}*/}
			{/*	onClick={pay}*/}
			{/* /> */}
		</div>
	);
};
